<template>
  <div
    class="flex-grow-1 d-flex flex-column align-center"
    style="height: 100%; background-color: rgb(250, 250, 250)"
  >
    <PlayerRegistration />
  </div>
</template>

<script>
import PlayerRegistration from "./PlayerRegistration";

export default {
  name: "PlayerRegistrationPage",
  components: { PlayerRegistration }
};
</script>

<style scoped></style>
